// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__4qbOd","title":"style_title__HDu4u","description":"style_description__5DLLG","actionIcon":"style_actionIcon__plmbR"};